<template>
  <div class="w-100 w-md-auto d-flex flex-column align-items-end">
    <div id="posting-container"
      :class="[hidePrint ? 'hide-print' : 'print bg-white', isIpadSafari ? 'ipad-safari-print' : '', isMacSafari ? 'safari-print' : '']">
      <h1 class="text-center font-weight-bold">
        Post at Primary Yards / Construction Sites
      </h1>
      <h3 class="text-center font-weight-bold">
        Department of Agriculture, Conservation and Forestry
      </h3>
      <h3 class="text-center font-weight-bold">
        Forest Operations Notification
      </h3>
      <h1 class="text-center font-weight-bold font-3xl mb-5">{{notification.fonNumber}}</h1>
      <h2 class="text-center">Operation Town:</h2>
      <h1 class="text-center font-weight-bold mb-5">
        {{townName}}
      </h1>
      <h2 class="text-center">Operation End Date:</h2>
      <h1 class="text-center font-weight-bold">
        {{notification.operationEndDate | dateString}}
      </h1>
      <h4 class="text-center font-weight-bold mb-5">
        Accepted by the Maine Department of Agriculture, Conservation and Forestry on
        {{notification.activeDate | dateString}}
      </h4>
      <img class="rounded mx-auto d-block" alt="mfs shield" src="@/assets/MFSShield.png" width="35%" />
    </div>
    <div class="d-flex flex-column flex-md-row justify-content-end w-100">
      <b-button
        class="hide-on-print mr-md-2 w-100 w-md-auto my-3"
        v-if="!loading && townName"
        @click="printPosting"
        pill
        aria-label="Print Posting"
      >
        Print Posting
      </b-button>
      <b-button
        class="hide-on-print w-100 w-md-auto my-3"
        v-if="!loading && townName"
        @click="printSummary"
        pill
        aria-label="Print Summary"
      >
        Print Summary
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LookupModules from '@/store/moduleConfig';

export default {
  name: 'PrintPosting',
  data() {
    return {
      hidePrint: true,
      isIpadSafari: false,
      isMacSafari: false,
    };
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
      loading: state => state.loading,
    }),
    ...mapGetters(LookupModules.TOWNS.namespace, ['getName']),
    townName() {
      return this.getName(this.notification.townGeocodeNum);
    },
  },
  methods: {
    getBrowser() {
      const userBrowser = window.navigator.userAgent.toLowerCase();
      switch (true) {
        case userBrowser.indexOf('edge') > -1: return 'edge';
        case userBrowser.indexOf('edg') > -1: return 'chromium based edge (dev or canary)';
        case userBrowser.indexOf('chrome') > -1 && !!window.chrome: return 'chrome';
        case userBrowser.indexOf('trident') > -1: return 'ie';
        case userBrowser.indexOf('firefox') > -1: return 'firefox';
        case userBrowser.indexOf('safari') > -1: return 'safari';
        default: return 'other';
      }
    },
    checkSafari() {
      const browser = this.getBrowser();
      let isIso = false;
      if (browser === 'safari') {
        if (/iPad|iPhone|iPod/.test(navigator.platform)) {
          isIso = true;
        } else if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform)) {
          isIso = true;
        }
        if (isIso) {
          return 'ipadSafari';
        }
        return 'macSafari';
      }
      return 'notSafari';
    },
    printPosting() {
      this.hidePrint = false;
      const clientBrowser = this.checkSafari();
      this.isIpadSafari = clientBrowser === 'ipadSafari';
      this.isMacSafari = clientBrowser === 'macSafari';
      this.$emit('printPosting');
    },
    printSummary() {
      this.$emit('printSummary');
    },
  },
};
</script>
